import { useState, useRef } from "react";

const IS_WAITLIST = typeof window !== "undefined" && window.location.pathname === "/waitlist";

const WaitlistPage = () => {
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const isMobile = window.innerWidth < 768;

  const submit = async () => {
    if (!email || !email.includes("@") || submitting) return;
    setSubmitting(true);
    try {
      await fetch("/api/waitlist", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, firstName }),
      });
    } catch (e) {
      console.error("Waitlist signup failed:", e);
    }
    setSubmitting(false);
    setConfirmed(true);
  };

  return (
    <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", background: "#FAF7F2", color: "#1A1A1A", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=Outfit:wght@300;400;500;600&display=swap');
        @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes expandLine { from { width: 0; } to { width: 60px; } }
        .north-cta:hover { background: #2A2A2A !important; transform: translateY(-1px); }
        input::placeholder { color: #B8B0A0; }
        input:focus { outline: none; border-color: #1A1A1A !important; }
      `}</style>

      <nav style={{ padding: isMobile ? "16px 24px" : "24px 40px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <a href="/" style={{ textDecoration: "none" }}>
          <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 15, fontWeight: 600, letterSpacing: 6, textTransform: "uppercase", color: "#1A1A1A" }}>North</div>
        </a>
      </nav>

      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: isMobile ? "24px 24px 60px" : "40px 40px 80px" }}>
        {!confirmed ? (
          <div style={{ maxWidth: 520, width: "100%", textAlign: "center" }}>
            <div style={{ width: 60, height: 1, background: "#C8B89A", margin: "0 auto 40px", animation: "expandLine 1.2s ease forwards" }} />
            <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, fontWeight: 500, letterSpacing: 3, textTransform: "uppercase", color: "#B8B0A0", marginBottom: 16, animation: "fadeUp 0.8s ease 0.1s both" }}>Early Access</div>
            <h1 style={{ fontSize: isMobile ? 34 : 48, fontWeight: 300, lineHeight: 1.15, margin: "0 0 24px 0", letterSpacing: -0.5, animation: "fadeUp 0.8s ease 0.2s both" }}>
              You're early.<br />
              <span style={{ fontStyle: "italic" }}>That matters.</span>
            </h1>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: isMobile ? 14 : 16, fontWeight: 300, color: "#4A4540", lineHeight: 1.8, margin: "0 auto 16px", maxWidth: 420, animation: "fadeUp 0.8s ease 0.4s both" }}>
              North is building a personalized financial guidance platform for people who think finance isn't for them.
            </p>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: isMobile ? 13 : 15, fontWeight: 300, color: "#6B6358", lineHeight: 1.7, margin: "0 auto 48px", maxWidth: 400, animation: "fadeUp 0.8s ease 0.5s both" }}>
              It starts where you actually are — not where you're supposed to be. We're not ready yet. Join the list and you'll be first to know when we are.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: 12, maxWidth: 400, margin: "0 auto", animation: "fadeUp 0.8s ease 0.6s both" }}>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                placeholder="First name"
                style={{ padding: "14px 20px", border: "1px solid #D5D0C8", borderRadius: 8, fontFamily: "'Outfit', sans-serif", fontSize: 14, fontWeight: 300, color: "#1A1A1A", background: "#FFFFFF", transition: "border-color 0.3s" }}
              />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && submit()}
                placeholder="Email address"
                style={{ padding: "14px 20px", border: "1px solid #D5D0C8", borderRadius: 8, fontFamily: "'Outfit', sans-serif", fontSize: 14, fontWeight: 300, color: "#1A1A1A", background: "#FFFFFF", transition: "border-color 0.3s" }}
              />
              <div
                onClick={submit}
                className={submitting ? "" : "north-cta"}
                style={{ padding: "16px 28px", background: submitting ? "#666" : "#1A1A1A", color: "#FAF7F2", borderRadius: 8, cursor: submitting ? "default" : "pointer", fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 500, letterSpacing: 1.5, textTransform: "uppercase", textAlign: "center", transition: "all 0.3s" }}
              >
                {submitting ? "..." : "Join the waitlist"}
              </div>
            </div>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, fontWeight: 300, color: "#B8B0A0", marginTop: 16, animation: "fadeUp 0.8s ease 0.8s both" }}>
              No cost. No commitment.
            </p>
          </div>
        ) : (
          <div style={{ maxWidth: 480, width: "100%", textAlign: "center" }}>
            <div style={{ width: 60, height: 1, background: "#C8B89A", margin: "0 auto 40px", animation: "expandLine 1s ease forwards" }} />
            <div style={{ width: 56, height: 56, borderRadius: "50%", background: "#C8B89A20", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 24px", fontSize: 24, animation: "fadeUp 0.8s ease 0.1s both" }}>&#10003;</div>
            <h2 style={{ fontSize: isMobile ? 28 : 36, fontWeight: 300, lineHeight: 1.2, margin: "0 0 16px 0", animation: "fadeUp 0.8s ease 0.2s both" }}>You're on the list.</h2>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: isMobile ? 13 : 15, fontWeight: 300, color: "#6B6358", lineHeight: 1.8, margin: "0 auto 40px", maxWidth: 380, animation: "fadeUp 0.8s ease 0.4s both" }}>
              We'll be in touch when North is ready. If you have questions before then, just reply to any email from us.
            </p>
            <p style={{ fontSize: 18, fontWeight: 300, fontStyle: "italic", color: "#1A1A1A", margin: "0 0 6px 0", animation: "fadeUp 0.8s ease 0.6s both" }}>This is your starting point.</p>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#B8B0A0", letterSpacing: 2, textTransform: "uppercase", animation: "fadeUp 0.8s ease 0.7s both" }}>North</p>
          </div>
        )}
      </div>

      <footer style={{ padding: "24px 40px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: "#C8B89A" }}>Built for people who think finance isn't for them.</div>
        <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: "#C8B89A" }}>© 2026 North</div>
      </footer>
    </div>
  );
};

const GA_ENABLED = typeof window !== "undefined" && typeof window.gtag === "function";

function trackEvent(eventName, params = {}) {
  if (GA_ENABLED) {
    window.gtag("event", eventName, params);
  }
}

const MainApp = () => {

  const [stage, setStage] = useState("landing");
  const [currentQ, setCurrentQ] = useState(0);
  const [answers, setAnswers] = useState({});
  const [email, setEmail] = useState("");
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [fadeIn, setFadeIn] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [headlineVariant] = useState(Math.random() > 0.5 ? "A" : "B");
  const containerRef = useRef(null);
  const viewContentFired = useRef(false);
  const leadFired = useRef(false);
  const [notionPageId, setNotionPageId] = useState(null);

  const questions = [
    {
      q: "When you hear the word \"finance,\" what comes to mind first?",
      options: [
        { text: "A world that isn't really meant for me", scores: { barrier: "identity", stage: 3 } },
        { text: "Something I should be doing more of", scores: { barrier: "avoidance", stage: 2 } },
        { text: "Stress", scores: { barrier: "emotional", stage: 3 } },
        { text: "Opportunity", scores: { barrier: "none", stage: 0 } },
        { text: "I try not to think about it", scores: { barrier: "avoidance", stage: 4 } },
      ],
    },
    {
      q: "How would you describe your relationship with money right now?",
      options: [
        { text: "We don't really talk", scores: { barrier: "avoidance", stage: 4 } },
        { text: "It's complicated", scores: { barrier: "emotional", stage: 3 } },
        { text: "We're getting to know each other", scores: { barrier: "knowledge", stage: 1 } },
        { text: "We're working on it, inconsistently", scores: { barrier: "behavioral", stage: 2 } },
        { text: "We're good, mostly", scores: { barrier: "none", stage: 0 } },
      ],
    },
    {
      q: "A friend casually mentions they started investing. Your honest gut reaction:",
      options: [
        { text: "Good for them, but that's not my world", scores: { barrier: "identity", stage: 4 } },
        { text: "I feel a little behind", scores: { barrier: "emotional", stage: 2 } },
        { text: "I'm curious how they started", scores: { barrier: "knowledge", stage: 1 } },
        { text: "I've thought about it but something always stops me", scores: { barrier: "avoidance", stage: 3 } },
        { text: "I'd love to compare notes", scores: { barrier: "none", stage: 0 } },
      ],
    },
    {
      q: "When a bank notification or financial email arrives, you typically:",
      options: [
        { text: "Open it right away", scores: { barrier: "none", stage: 0 } },
        { text: "Glance and tell myself I'll deal with it later", scores: { barrier: "avoidance", stage: 2 } },
        { text: "Feel a small knot before opening it", scores: { barrier: "emotional", stage: 3 } },
        { text: "Let it sit unopened for a while", scores: { barrier: "avoidance", stage: 4 } },
        { text: "Depends on how I'm feeling", scores: { barrier: "behavioral", stage: 2 } },
      ],
    },
    {
      q: "Which of these sounds most like something you've said or thought?",
      options: [
        { text: "\"I'll figure this out once I'm making more money\"", scores: { barrier: "avoidance", stage: 2 } },
        { text: "\"I should probably know more about this by now\"", scores: { barrier: "emotional", stage: 2 } },
        { text: "\"I'm just not a numbers person\"", scores: { barrier: "identity", stage: 3 } },
        { text: "\"I've made too many mistakes to fix things now\"", scores: { barrier: "emotional", stage: 4 } },
        { text: "\"I want to start but I don't know the first step\"", scores: { barrier: "knowledge", stage: 1 } },
      ],
    },
    {
      q: "When you imagine talking to someone about your finances, what feeling comes up first?",
      options: [
        { text: "Relief, actually. I wish I could.", scores: { trigger: "trust", stage: 1 } },
        { text: "Embarrassment about where I'm starting from", scores: { barrier: "emotional", stage: 3 } },
        { text: "Fear of being judged", scores: { barrier: "privacy", stage: 3 } },
        { text: "I wouldn't know what to ask", scores: { barrier: "knowledge", stage: 2 } },
        { text: "I've tried before and it didn't help", scores: { barrier: "behavioral", stage: 3 } },
      ],
    },
    {
      q: "What kind of moment would make you take a different path with money?",
      options: [
        { text: "A major life change forcing my hand", scores: { trigger: "life", stage: 2 } },
        { text: "Hitting a breaking point with the stress", scores: { trigger: "crisis", stage: 3 } },
        { text: "Seeing someone like me actually succeed at it", scores: { trigger: "social", stage: 2 } },
        { text: "Finding someone I genuinely trust to guide me", scores: { trigger: "trust", stage: 2 } },
        { text: "Realizing how much time I've already lost", scores: { trigger: "time", stage: 3 } },
      ],
    },
    {
      q: "When you think about where you are financially compared to where you thought you'd be:",
      options: [
        { text: "I try not to think about it", scores: { barrier: "avoidance", stage: 4 } },
        { text: "I feel significantly behind", scores: { barrier: "emotional", stage: 3 } },
        { text: "I'm okay but could be doing more", scores: { barrier: "behavioral", stage: 1 } },
        { text: "I'm not sure what I should compare to", scores: { barrier: "knowledge", stage: 2 } },
        { text: "I'm roughly where I expected", scores: { barrier: "none", stage: 0 } },
      ],
    },
    {
      q: "Have you ever caught yourself thinking \"this just isn't for someone like me\"?",
      options: [
        { text: "All the time", scores: { barrier: "identity", stage: 4 } },
        { text: "Sometimes, even though I know it's not rational", scores: { barrier: "identity", stage: 3 } },
        { text: "I used to, but I'm starting to move past it", scores: { barrier: "identity", stage: 1 } },
        { text: "Not exactly, but I feel out of my depth", scores: { barrier: "knowledge", stage: 2 } },
        { text: "No, I feel like I belong in this space", scores: { barrier: "none", stage: 0 } },
      ],
    },
    {
      q: "If you could change one thing about how you relate to money, it would be:",
      options: [
        { text: "Feeling like I actually understand what I'm doing", scores: { desire: "knowledge", stage: 2 } },
        { text: "Stopping the cycle of avoiding and then feeling guilty", scores: { desire: "behavioral", stage: 3 } },
        { text: "Believing that it's not too late for me", scores: { desire: "emotional", stage: 3 } },
        { text: "Having a clear first step that feels doable", scores: { desire: "action", stage: 1 } },
        { text: "Feeling confident enough to make my own decisions", scores: { desire: "identity", stage: 2 } },
      ],
    },
  ];

  const computeResults = (answersObj) => {
    let totalStage = 0;
    let barrierCounts = {};
    let count = 0;
    Object.values(answersObj).forEach((a) => {
      totalStage += a.scores.stage;
      count++;
      const barrier = a.scores.barrier || a.scores.trigger || a.scores.desire;
      if (barrier) barrierCounts[barrier] = (barrierCounts[barrier] || 0) + 1;
    });
    const avgStage = totalStage / Math.max(count, 1);
    const topBarrier = Object.entries(barrierCounts).sort((a, b) => b[1] - a[1])[0]?.[0] || "emotional";

    if (avgStage <= 1) return { id: "early-explorer", title: "The Early Explorer", tagline: "You're closer to the starting line than you think.", reframe: "You have curiosity and openness that most people never find. The fact that you're here, answering these questions, means you've already cleared the hardest hurdle. You don't need to know everything. You just need to take the next step, and it's smaller than you imagine.", step: "Tell someone in your life that you're starting to think about your money differently. That sentence, said out loud, makes it real. You don't need a plan yet. You just need a witness.", color: "#3A9E96", topBarrier };
    if (avgStage <= 2.2) return { id: "quiet-avoider", title: "The Quiet Avoider", tagline: "You know you should start. Something keeps pulling you back.", reframe: "You're not lazy or irresponsible. You're caught in a pattern that millions of smart, capable people share. The avoidance isn't a character flaw. It's a protection mechanism your brain built because, at some point, engaging with money felt unsafe or overwhelming. That pattern can be interrupted. And the fact that you recognize it puts you ahead of most.", step: "Tonight, open your banking app and just look at your balance. Don't judge it. Don't plan anything. Just look. Break the avoidance with one small act of seeing.", color: "#C4883A", topBarrier };
    if (avgStage <= 3.2) return { id: "stuck-starter", title: "The Stuck Starter", tagline: "You've been carrying this longer than you needed to.", reframe: "The shame you feel about money isn't based on reality. It's based on a story you've been telling yourself, one that probably started long before you were earning a paycheck. Here's what's actually true: you have income, you have intelligence, and you now have awareness. That's more than enough to begin. The years you spent avoiding this weren't wasted. They taught you what doesn't work. Now you're ready for what does.", step: "Write down the one financial question you've been too embarrassed to ask anyone. Then ask it. You can ask us. That question is your key.", color: "#B85840", topBarrier };
    return { id: "silent-fighter", title: "The Silent Fighter", tagline: "You've been at war with this for a long time. It's time to put the weapon down.", reframe: "You are not your worst financial moment. You are not the debt, the missed opportunity, or the years of silence. You are someone who has survived all of that and is still here, still looking for a way forward. That takes more strength than any spreadsheet could measure. The cycle you're in, where belief feeds avoidance and avoidance steals time, is real. But it breaks the moment you let someone in. This isn't the end of a story. It's the turn.", step: "Forgive yourself for one financial decision you regret. Say it out loud or write it down: \"I did the best I could with what I knew.\" Then close that chapter. Tomorrow, we start a new one.", color: "#9B4040", topBarrier };
  };

  const getResults = () => computeResults(answers);

  const transition = (callback) => {
    setFadeIn(false);
    setTimeout(() => { callback(); setFadeIn(true); if (containerRef.current) containerRef.current.scrollTo({ top: 0, behavior: "smooth" }); }, 400);
  };

  const selectAnswer = (option, index) => {
    setSelectedAnswer(index);
    trackEvent("question_answered", { question: currentQ + 1, answer: option.text });
    setTimeout(() => {
      const newAnswers = { ...answers, [currentQ]: option };
      setAnswers(newAnswers);
      setSelectedAnswer(null);
      if (currentQ < questions.length - 1) {
        transition(() => setCurrentQ(currentQ + 1));
      } else {
        trackEvent("diagnostic_completed", { variant: headlineVariant });
        const completedResult = computeResults(newAnswers);
        const sessionId = Math.random().toString(36).substr(2, 9);
        fetch("/api/track-result", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ profile: completedResult.id, barrier: completedResult.topBarrier, variant: headlineVariant, session: sessionId }),
        }).then((r) => r.json()).then((data) => { if (data.pageId) setNotionPageId(data.pageId); }).catch(() => {});
        transition(() => {
          setStage("results");
          if (!viewContentFired.current && typeof window.rdt === "function") {
            window.rdt("track", "ViewContent");
            viewContentFired.current = true;
          }
        });
      }
    }, 600);
  };

  const submitEmail = async (path) => {
    if (!email || !email.includes("@") || submitting) return;
    setSubmitting(true);
    const result = getResults();
    const interestType = path === "A" ? "paid_waitlist" : "free_report";
    trackEvent("email_submitted", { profile: result.id, variant: headlineVariant, barrier: result.topBarrier });
    try {
      await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          profile: result.id,
          variant: headlineVariant,
          barrier: result.topBarrier || "",
          interest_type: interestType,
        }),
      });
    } catch (e) {
      console.error("Subscription failed:", e);
    }
    if (notionPageId) {
      fetch("/api/update-result", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pageId: notionPageId, email }),
      }).catch(() => {});
    }
    setSubmitting(false);
    if (!leadFired.current && typeof window.rdt === "function") {
      window.rdt("track", "Lead");
      leadFired.current = true;
    }
    if (path === "A" && typeof window.rdt === "function") {
      window.rdt("track", "Custom", { customEventName: "WaitlistInterest" });
    }
    transition(() => setStage("confirmed"));
  };

  const results = (stage === "results" || stage === "email" || stage === "confirmed") ? getResults() : null;
  const isMobile = window.innerWidth < 768;

  return (
    <div ref={containerRef} style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", background: "#FAF7F2", color: "#1A1A1A", minHeight: "100vh", display: "flex", flexDirection: "column", overflow: "auto" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=Outfit:wght@300;400;500;600&display=swap');
        @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes expandLine { from { width: 0; } to { width: 60px; } }
        .north-option:hover { background: #F0EDE6 !important; border-color: #C8B89A !important; }
        .north-option-selected { background: #1A1A1A !important; color: #FAF7F2 !important; border-color: #1A1A1A !important; }
        .north-cta:hover { background: #2A2A2A !important; transform: translateY(-1px); }
        .north-cta-light:hover { background: #1A1A1A !important; color: #FAF7F2 !important; }
        .north-path-a-btn:hover { background: #256860 !important; transform: translateY(-1px); }
        .north-path-b-btn:hover { background: #F0EDE7 !important; }
        input::placeholder { color: #B8B0A0; }
        input:focus { outline: none; border-color: #1A1A1A !important; }
      `}</style>

      <nav style={{ padding: isMobile ? "16px 24px" : "24px 40px", display: "flex", justifyContent: "space-between", alignItems: "center", animation: "fadeIn 1s ease" }}>
        <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 15, fontWeight: 600, letterSpacing: 6, textTransform: "uppercase", color: "#1A1A1A", cursor: "pointer" }} onClick={() => { setStage("landing"); setCurrentQ(0); setAnswers({}); setEmail(""); }}>North</div>
      </nav>

      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: isMobile ? "16px 20px 40px" : "20px 40px 60px", opacity: fadeIn ? 1 : 0, transform: fadeIn ? "translateY(0)" : "translateY(10px)", transition: "all 0.4s ease" }}>

        {stage === "landing" && (
          <div style={{ maxWidth: 720, textAlign: "center" }}>
            <div style={{ width: 60, height: 1, background: "#C8B89A", margin: isMobile ? "0 auto 20px" : "0 auto 40px", animation: "expandLine 1.2s ease forwards" }} />
            <h1 style={{ fontSize: isMobile ? 30 : 48, fontWeight: isMobile ? 400 : 300, lineHeight: 1.15, margin: isMobile ? "0 0 14px 0" : "0 0 24px 0", letterSpacing: -0.5, animation: "fadeUp 1s ease 0.2s both" }}>
              {headlineVariant === "A"
                ? <>You're not bad with money.<br /><span style={{ fontStyle: "italic", fontWeight: 400 }}>You just never had the right starting point.</span></>
                : <>Most financial advice skips<br /><span style={{ fontStyle: "italic", fontWeight: 400 }}>the part that actually matters: you.</span></>
              }
            </h1>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: isMobile ? 14 : 16, fontWeight: 300, color: "#4A4540", lineHeight: 1.7, margin: isMobile ? "0 auto 10px" : "0 auto 16px", maxWidth: 480, animation: "fadeUp 1s ease 0.5s both" }}>
              Before the budgets, the apps, and the investment accounts, there's something most people never address: why you haven't started.
            </p>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: isMobile ? 13 : 14, fontWeight: 400, color: "#1A1A1A", lineHeight: 1.6, margin: isMobile ? "0 auto 18px" : "0 auto 36px", maxWidth: 460, animation: "fadeUp 1s ease 0.6s both" }}>
              In 2 minutes, discover your personal <strong>Starting Point</strong> — what's really been holding you back, and one clear step to change it.
            </p>
            <div style={{ animation: "fadeUp 1s ease 0.8s both", width: isMobile ? "100%" : "auto" }}>
              <div onClick={() => { trackEvent("start_clicked", { variant: headlineVariant }); transition(() => setStage("diagnostic")); }} style={{ display: isMobile ? "block" : "inline-block", textAlign: "center", fontFamily: "'Outfit', sans-serif", fontSize: 14, fontWeight: 500, letterSpacing: 1.5, textTransform: "uppercase", color: "#FAF7F2", background: "#1A1A1A", padding: "16px 48px", borderRadius: 100, cursor: "pointer", transition: "all 0.3s" }} className="north-cta">Find my starting point</div>
            </div>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#B8B0A0", marginTop: 16, animation: "fadeUp 1s ease 1s both" }}>
              No financial data required. No sign-up needed to begin.
            </p>
            <div style={{ marginTop: isMobile ? 28 : 48, display: "flex", justifyContent: "center", gap: isMobile ? 24 : 40, animation: "fadeUp 1s ease 1.1s both" }}>
              {[{ number: "2 min", label: "to complete" }, { number: "10", label: "questions" }, { number: "0", label: "financial data needed" }].map((item, i) => (
                <div key={i} style={{ textAlign: "center" }}>
                  <div style={{ fontSize: 28, fontWeight: 300, color: "#1A1A1A" }}>{item.number}</div>
                  <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, fontWeight: 400, color: "#B8B0A0", marginTop: 4, letterSpacing: 1, textTransform: "uppercase" }}>{item.label}</div>
                </div>
              ))}
            </div>
            {/* Founder social proof */}
            <div style={{ marginTop: isMobile ? 28 : 56, padding: isMobile ? "24px 20px" : "28px 32px", background: "#F0EDE6", borderRadius: 12, textAlign: "left", animation: "fadeUp 1s ease 1.3s both" }}>
              <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 300, color: "#6B6358", lineHeight: 1.7, margin: "0 0 20px 0", fontStyle: "italic" }}>
                "The hardest part of getting good with money isn't the money. It's finding where to start. I've worked with hundreds of students and professionals, and the pattern is always the same: they're smart, they're capable, and they're completely stuck. Not because they lack information, but because nobody ever showed them their starting point. That's what North does."
              </p>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ width: 44, height: 44, borderRadius: "50%", background: "#D5D0C8", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  {/* Replace with: <img src="/photo.png" alt="Arseniy" style={{width:'100%',height:'100%',objectFit:'cover'}} /> */}
                  <img src="/photo.png" alt="Arseniy" style={{width:'100%',height:'100%',objectFit:'cover'}} />
                </div>
                <div>
                  <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 500, color: "#1A1A1A" }}>Arseniy Goldberg, Founder at North</div>
                  <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, fontWeight: 300, color: "#8A8279", lineHeight: 1.5 }}>
                    Professor of Finance at IE Business School &amp; Oregon State University · Financial Consultant at Baird · Partner at Flow.
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {stage === "diagnostic" && (
          <div style={{ maxWidth: 520, width: "100%", textAlign: "center" }}>
            <div style={{ marginBottom: 48 }}>
              <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, fontWeight: 400, letterSpacing: 3, textTransform: "uppercase", color: "#B8B0A0", marginBottom: 12 }}>{currentQ + 1} of {questions.length}</div>
              <div style={{ width: "100%", height: 2, background: "#E5E0D8", borderRadius: 1 }}>
                <div style={{ width: `${((currentQ + 1) / questions.length) * 100}%`, height: "100%", background: "#1A1A1A", borderRadius: 1, transition: "width 0.6s ease" }} />
              </div>
            </div>
            <h2 style={{ fontSize: 28, fontWeight: 600, lineHeight: 1.35, margin: "0 0 36px 0", color: "#1A1A1A", animation: "fadeUp 0.6s ease both" }}>{questions[currentQ].q}</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {questions[currentQ].options.map((opt, i) => (
                <div key={i} onClick={() => selectAnswer(opt, i)} className={`north-option ${selectedAnswer === i ? "north-option-selected" : ""}`} style={{ padding: "16px 24px", borderRadius: 8, border: "1px solid #E5E0D8", cursor: "pointer", transition: "all 0.3s", textAlign: "left", fontFamily: "'Outfit', sans-serif", fontSize: 14, fontWeight: 300, color: "#1A1A1A", lineHeight: 1.4, animation: `fadeUp 0.5s ease ${0.1 + i * 0.06}s both` }}>
                  {opt.text}
                </div>
              ))}
            </div>
          </div>
        )}

        {stage === "results" && results && (
          <div style={{ maxWidth: 580, width: "100%", textAlign: "center" }}>
            <div style={{ width: 60, height: 1, background: results.color, margin: "0 auto 32px", animation: "expandLine 1s ease forwards" }} />
            <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, fontWeight: 500, letterSpacing: 3, textTransform: "uppercase", color: "#B8B0A0", marginBottom: 12, animation: "fadeUp 0.8s ease 0.1s both" }}>Your Starting Point</div>
            <h2 style={{ fontSize: 42, fontWeight: 300, lineHeight: 1.2, margin: "0 0 8px 0", color: "#1A1A1A", animation: "fadeUp 0.8s ease 0.3s both" }}>{results.title}</h2>
            <p style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 19, fontWeight: 500, fontStyle: "italic", color: results.color, margin: "0 0 40px 0", animation: "fadeUp 0.8s ease 0.5s both", lineHeight: 1.5 }}>{results.tagline}</p>
            <div style={{ textAlign: "left", padding: isMobile ? "24px 20px" : 32, background: "#FFFFFF", borderRadius: 16, marginBottom: 20, boxShadow: "0 2px 24px rgba(0,0,0,0.05)", animation: "fadeUp 0.8s ease 0.7s both" }}>
              <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 10, fontWeight: 600, letterSpacing: 3, textTransform: "uppercase", color: "#C8B89A", marginBottom: 14 }}>What's actually true</div>
              <p style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 20, fontWeight: 500, lineHeight: 1.75, color: "#1A1A1A", margin: 0 }}>{results.reframe}</p>
            </div>
            <div style={{ textAlign: "left", padding: isMobile ? "24px 20px" : 32, background: "#1C1C1C", borderRadius: 16, marginBottom: 32, animation: "fadeUp 0.8s ease 0.9s both" }}>
              <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 10, fontWeight: 600, letterSpacing: 3, textTransform: "uppercase", color: results.color, marginBottom: 14, opacity: 0.9 }}>Your one next step</div>
              <p style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 20, fontWeight: 500, lineHeight: 1.75, color: "#F0EDE7", margin: 0 }}>{results.step}</p>
            </div>
            {/* CTA Card */}
            {(() => {
              return (
                <>
                  <div style={{ background: "#F0EDE7", border: "1px solid #E0DCD6", borderRadius: 20, padding: isMobile ? "28px 24px" : "36px 32px", animation: "fadeUp 0.8s ease 1.1s both" }}>
                    <img src="/north_logo_dark_wide.png" alt="North" style={{ height: 28, marginBottom: 28 }} />
                    <h3 style={{ fontFamily: "'Outfit', sans-serif", fontSize: isMobile ? 22 : 26, fontWeight: 700, color: "#1A1A1A", margin: "0 0 32px 0", lineHeight: 1.2 }}>The First Financial App Built For You.</h3>
                    <ul style={{ listStyle: "none", padding: 0, margin: "0 0 40px 0", display: "flex", flexDirection: "column", gap: 16 }}>
                      {[
                        "Built from your Starting Point. Not someone else's.",
                        "Learn money management, step by step, at your level.",
                        "Ask anything. Real answers. No judgment.",
                      ].map((item, i) => (
                        <li key={i} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                          <span style={{ color: "#C8B89A", fontWeight: 700, fontSize: 18, flexShrink: 0, lineHeight: 1 }}>—</span>
                          <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, fontWeight: 500, color: "#2A2420", lineHeight: 1.4 }}>{item}</span>
                        </li>
                      ))}
                    </ul>
                    <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: 10 }}>
                      <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submitEmail("B")} placeholder="Your email" autoFocus style={{ flex: 1, padding: "14px 18px", border: "1px solid #D5D0C8", borderRadius: 8, fontFamily: "'Outfit', sans-serif", fontSize: 15, color: "#1A1A1A", background: "#FFFFFF" }} />
                      <div onClick={() => submitEmail("B")} style={{ padding: "16px 24px", background: submitting ? "#256860" : "#2D7A6A", color: "#FFFFFF", borderRadius: 8, cursor: submitting ? "default" : "pointer", fontFamily: "'Outfit', sans-serif", fontSize: 17, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", whiteSpace: "nowrap", minHeight: 56 }}>{submitting ? "..." : "Send me my portrait"}</div>
                    </div>
                    <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 300, color: "#8B7355", textAlign: "center", margin: "16px 0 0 0" }}>We'll also let you know when North launches for your profile.</p>
                  </div>
                </>
              );
            })()}
            <div style={{ marginTop: 40, animation: "fadeUp 0.8s ease 1.5s both" }}>
              <div style={{ width: 40, height: 1, background: "#E5E0D8", margin: "0 auto 20px" }} />
              <p style={{ fontSize: 18, fontWeight: 300, fontStyle: "italic", color: "#1A1A1A", margin: "0 0 6px 0" }}>This is your starting point.</p>
              <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#B8B0A0", letterSpacing: 2, textTransform: "uppercase" }}>North</p>
            </div>
          </div>
        )}

        {stage === "confirmed" && results && (
          <div style={{ maxWidth: 480, width: "100%", textAlign: "center", boxSizing: "border-box", padding: isMobile ? "0 4px" : 0 }}>
            <div style={{ width: 60, height: 1, background: results.color, margin: "0 auto 32px", animation: "expandLine 1s ease forwards" }} />
            <div style={{ width: 56, height: 56, borderRadius: "50%", background: results.color + "20", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 24px", animation: "fadeUp 0.8s ease 0.2s both" }}>
              <span style={{ fontSize: 24 }}>&#10003;</span>
            </div>
            <h2 style={{ fontSize: isMobile ? 26 : 32, fontWeight: 300, lineHeight: 1.2, margin: "0 0 16px 0", color: "#1A1A1A", animation: "fadeUp 0.8s ease 0.3s both" }}>Check your inbox.</h2>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: isMobile ? 13 : 15, fontWeight: 300, color: "#6B6358", lineHeight: 1.7, margin: "0 0 40px 0", animation: "fadeUp 0.8s ease 0.5s both" }}>
              Your full Starting Point report is on its way. It includes a deeper analysis of your patterns, three personalized steps, and resources built for where you are right now.
            </p>
            <div style={{ padding: 28, background: "#F0EDE6", borderRadius: 12, textAlign: "left", animation: "fadeUp 0.8s ease 0.7s both" }}>
              <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, fontWeight: 400, color: "#6B6358", lineHeight: 1.7, margin: 0 }}>
                <strong style={{ color: "#1A1A1A" }}>One thing while you wait:</strong> What's the one thing you wish someone had told you about money earlier? Reply to the email when it arrives. We read every response.
              </p>
            </div>
            <div style={{ marginTop: 40, animation: "fadeUp 0.8s ease 0.9s both" }}>
              <div style={{ width: 40, height: 1, background: "#E5E0D8", margin: "0 auto 20px" }} />
              <p style={{ fontSize: 18, fontWeight: 300, fontStyle: "italic", color: "#1A1A1A", margin: "0 0 6px 0" }}>This is your starting point.</p>
              <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#B8B0A0", letterSpacing: 2, textTransform: "uppercase" }}>North</p>
            </div>
          </div>
        )}
      </div>

      {stage === "landing" && (
        <footer style={{ padding: "24px 40px", display: "flex", justifyContent: "space-between", alignItems: "center", animation: "fadeIn 1s ease 1.5s both" }}>
          <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: "#C8B89A" }}>Built for people who think finance isn't for them.</div>
          <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, color: "#C8B89A" }}>© 2026 North</div>
        </footer>
      )}
    </div>
  );
};

const App = () => IS_WAITLIST ? <WaitlistPage /> : <MainApp />;

export default App;
